import { Component, OnInit } from "@angular/core";

@Component({
	selector: "caass-parent-portal-app-reg",
	templateUrl: "./parent-portal-app-reg.component.html",
	styleUrls: ["./parent-portal-app-reg.component.css"],
})
export class ParentPortalAppRegComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	////////////////////////////////////////
	// Data
	////////////////////////////////////////

	Mode: string = "Student"; // Student | Parent

	////////////////////////////////////////
}
